import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { IViewerStore } from './viewer.store';
import { MediaType, ViewerStore } from './viewer.types';

export interface MediaState {
  mediaList: MediaType | null;
  currentPlayingMedia: MediaType[number][string] | null;
}

export interface MediaActions {
  setMediaList: (info: MediaType[number][string]) => void;
  setCurrentPlayingMedia: (info: ViewerStore['currentPlayingMedia']) => void;
}

export type MediaSlice = MediaState & MediaActions;

export const createMediaSlice: StateCreator<IViewerStore, [], [], MediaSlice> = (set) => ({
  mediaList: null,
  currentPlayingMedia: null,

  setMediaList: (info) =>
    set(
      produce((draft) => {
        draft.mediaList = {
          ...(draft.mediaList || {}),
          [info.pageId]: {
            ...(draft.mediaList?.[info.pageId] || {}),
            [info.svgId]: {
              ...(draft.mediaList?.[info.pageId]?.[info.svgId] || {}),
              ...info,
            },
          },
        };
      })
    ),
  setCurrentPlayingMedia: (info) =>
    set(
      produce((draft) => {
        if (info) {
          draft.currentPlayingMedia = {
            ...(draft.currentPlayingMedia ?? draft.mediaList?.[info.pageId]?.[info.svgId] ?? {}),
            ...info,
          };

          return;
        }

        draft.currentPlayingMedia = null;
      })
    ),
});
